import {
  type Image1Card,
  Image1CardSchema,
  type Image2Card,
  Image2CardSchema,
  type Image3Card,
  Image3CardSchema,
  type Image4Card,
  Image4CardSchema,
  type Image5Card,
  Image5CardSchema,
} from "@stackje/common/config";
import { ValidationError } from "./validation";

type ImageCard = Image1Card | Image2Card | Image3Card | Image4Card | Image5Card;

export function parseImageCard(formData: FormData): ImageCard {
  const type = formData.get("type") as ImageCard["type"];
  const baseCard = {
    colors: JSON.parse(formData.get("colors") as string),
    title: (formData.get("title") as string) || undefined,
    description: (formData.get("description") as string) || undefined,
  };

  // Parse images from indexed form fields
  const images = [];
  let i = 0;
  while (formData.has(`imageSrc${i}`)) {
    images.push({
      image: {
        src: formData.get(`imageSrc${i}`) as string,
        alt: (formData.get(`imageAlt${i}`) as string) || undefined,
      },
      caption: (formData.get(`imageCaption${i}`) as string) || undefined,
    });
    i++;
  }

  const cardData = { ...baseCard, type, images };

  try {
    switch (type) {
      case "image1":
        return Image1CardSchema.parse(cardData);
      case "image2":
        return Image2CardSchema.parse(cardData);
      case "image3":
        return Image3CardSchema.parse(cardData);
      case "image4":
        return Image4CardSchema.parse(cardData);
      case "image5":
        return Image5CardSchema.parse(cardData);
      default:
        throw new Error(`Invalid image card type: ${type}`);
    }
  } catch (error) {
    if (error instanceof Error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw new ValidationError(error as any);
    }
    throw error;
  }
}